import { render, staticRenderFns } from "./AddStoreGiftListCategoryComponent.vue?vue&type=template&id=647e27da&scoped=true"
import script from "./AddStoreGiftListCategoryComponent.vue?vue&type=script&lang=js"
export * from "./AddStoreGiftListCategoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647e27da",
  null
  
)

export default component.exports